/**
 * Link to the Capital One Google Sheet a flow's input comes from, shown on the
 * first step of the Greenlight / Reorder / Backbook modals. The sheets are only
 * readable from the dev@re3gift.com login, so the account is spelled out.
 */

const TONES = {
  emerald: 'bg-emerald-50 border-emerald-200 text-emerald-800 hover:text-emerald-900',
  amber: 'bg-amber-50 border-amber-200 text-amber-800 hover:text-amber-900',
  sky: 'bg-sky-50 border-sky-200 text-sky-800 hover:text-sky-900',
};

export default function SourceSheetLink({ href, label, tone = 'emerald' }) {
  return (
    <div className={`border rounded-lg px-4 py-2.5 mb-4 text-xs flex items-start gap-2 ${TONES[tone] || TONES.emerald}`}>
      <svg className="w-4 h-4 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
      </svg>
      <span>
        Visit{' '}
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium underline underline-offset-2 break-all"
        >
          the Google Sheet
        </a>{' '}
        logged in as <span className="font-mono">dev@re3gift.com</span> {label}
      </span>
    </div>
  );
}
